export default "__VITE_ASSET__4d315486__"